import { createClient } from '@libsql/client';

const db = createClient({
  url: import.meta.env.VITE_TURSO_DB_URL,
  authToken: import.meta.env.VITE_TURSO_AUTH_TOKEN
});

const DEFAULT_VALUATION_FORM_CONTENT = {
  lastUpdated: new Date().toISOString(),
  hero: {
    heading: "Request A Free Valuation Of Your Property",
    description: "Our real estate company has a number of luxury and exclusive listings that are perfect for international clients.",
contact: {
      text: "+91 98 488 22 522",
      link: "tel:+919848822522"
    }
  },
  form: {
    personalInfoHeading: "Personal Information",
    propertyInfoHeading: "Property Information",
    submitButtonText: "Submit"
  }
};

const ensureTableExists = async () => {
  try {
    await db.execute(`
      CREATE TABLE IF NOT EXISTS valuation_form_content (
        id TEXT PRIMARY KEY,
        content_data TEXT NOT NULL,
        updated_at TEXT NOT NULL
      );
    `);
  } catch (error) {
    console.error("Error ensuring valuation_form_content table exists:", error);
  }
};

const valuationFormService = {
  async getValuationFormContent() {
    await ensureTableExists();
    try {
      const result = await db.execute({
        sql: `SELECT content_data, updated_at FROM valuation_form_content WHERE id = ?;`,
        args: ['valuation-form']
      });

      if (result.rows.length > 0) {
        const content = JSON.parse(result.rows[0].content_data);
        content.lastUpdated = result.rows[0].updated_at;
        return content;
      } else {
        console.log('No content found for Valuation Form, returning default and saving it.');
        await this.createOrUpdateValuationFormContent(DEFAULT_VALUATION_FORM_CONTENT);
        return DEFAULT_VALUATION_FORM_CONTENT;
      }
    } catch (error) {
      console.error("Error fetching Valuation Form content:", error);
      throw new Error('Could not fetch Valuation Form content from database.');
    }
  },

  async createOrUpdateValuationFormContent(content) {
    await ensureTableExists();
    const now = new Date().toISOString();
    try {
      const serializedContent = JSON.stringify({ ...content, lastUpdated: now });
      await db.execute({
        sql: `
          INSERT INTO valuation_form_content (id, content_data, updated_at) VALUES (?, ?, ?)
          ON CONFLICT(id) DO UPDATE SET content_data = ?, updated_at = ?;
        `,
        args: [
          'valuation-form',
          serializedContent,
          now,
          serializedContent,
          now
        ],
      });
      console.log('Valuation Form content created or updated successfully!');
      return { ...content, lastUpdated: now };
    } catch (error) {
      console.error("Error creating or updating Valuation Form content:", error);
      throw new Error('Could not save Valuation Form content to database.');
    }
  }
};

export { valuationFormService };